import ProviderFoodCard from "./ProviderFoodCard";
import "./ProviderFoodGrid.css";

export default function ProviderFoodGrid({
  foods = [],
  search = "",
  selectedCategory = "All",
}) {

  const searchText = search.toLowerCase().trim();

  const filteredFoods = foods.filter((food) => {

    const matchesCategory =
      selectedCategory === "All" ||
      food.category === selectedCategory;

    const matchesSearch =
      food.foodName
        ?.toLowerCase()
        .includes(searchText) ||
      food.category
        ?.toLowerCase()
        .includes(searchText);

    return matchesCategory && matchesSearch;
  });

  if (filteredFoods.length === 0) {

    return (
      <div className="provider-empty-foods">

        <img
          src="/images/no-food.png"
          alt="No Foods"
        />

        <h2>No Foods Found</h2>

        <p>
          Try another category or search keyword.
        </p>

      </div>
    );

  }

  return (

    <div className="provider-food-grid">

      {filteredFoods.map((food) => (

        <ProviderFoodCard
          key={food._id}
          food={food}
        />

      ))}

    </div>

  );
}